export default __webpack_public_path__ + "static/media/search.e1f3ec1b.svg";